/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { viewSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListViewSelect";
import List from "@monsma/XDL/Icons/List";
import ThLarge from "@monsma/XDL/Icons/ThLarge";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};

viewSelectStyles.listViewIcon = {
    src: List,
    size: 20,
};

viewSelectStyles.gridViewIcon = {
    src: ThLarge,
    size: 20,
};

viewSelectStyles.gridViewClickable = {};
